import React, { useEffect, useState, useCallback } from "react";
import { useWatchState, useModal } from "@/store";
import { BaseService } from "@/service";
import { Modal } from "antd";
import { checkResult, createFilePath, second2Date } from "@/common";
import bgPng from "./images/bg.png";
import "../../../assets/lib/output.css";
import "./style.less";

const NAME = "innovateInfo";

const App = () => {
  const [innovateInfoModal] = useModal(["innovateInfo"]);
  const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
  const [[{ show, hide, width = 1000, id = "" }]] = useWatchState([
    "modal." + NAME,
  ]);

  const [data, setData] = useState({});
  const [relevant, setRelevant] = useState([]);

  useEffect(() => {
    if (id) {
      BaseService.list({
        table: "thtt_innovate",
        columns: "id,title,content,type",
        where: {
          id,
          is_delete: 0,
        },
      }).then((res) => {
        if (!checkResult(res)) return;
        const data = res.data.result[0] || {};
        setData(data);
      });
    } else setData({});
  }, [id]);

  useEffect(() => {
    if (data.id && data.type) {
      getRelevant();
    }
  }, [data]);

  // 查询相关列表
  const getRelevant = useCallback(() => {
    BaseService.list({
      table: "thtt_innovate",
      columns: "id,title,cover,add_time,source,content",
      where: {
        type: data.type,
        id: {
          condition: "!=",
          value: data.id,
        },
      },
    }).then((res) => {
      setRelevant(res.data.result || []);
    });
  }, [data]);

  const showDetail = useCallback((id) => {
    innovateInfoModal.show({ id });
  }, []);

  return (
    <Modal
      visible={show}
      width={width}
      className="m-innovateInfo"
      maskClosable={false}
      destroyOnClose
      onCancel={hide}
      footer={false}
    >
      <div className="relative">
        <img className="w-full" src={bgPng} alt="" />
        <h2 className="absolute w-full text-center text-white m-innovateInfo_title">
          {data.title}
        </h2>
      </div>
      <div className="px-30 pt-30 flex">
        {/* 内容 */}
        <div className="pb-30">
          <p className="relevant-title">Introduction</p>
          {data.content !== "<p></p>" && (
            <article className="m-md-t">
              <div
                className="m-sm-t braft-output-content"
                dangerouslySetInnerHTML={{ __html: data.content }}
              ></div>
            </article>
          )}
        </div>

        {/* 列表 */}
        <div
          style={{ width: "300px" }}
          className="flex-shrink-0 m-md-l child-top-md border-left p-md-l"
        >
          <p className="relevant-title">Relevant</p>
          {relevant.map(({ id, title, cover, content, add_time, source }) => (
            <div
              key={id}
              className="flex flex-col pb-10 border-bottom"
              onClick={showDetail.bind(null, id)}
            >
              <p className="bold dark-title pointer link">{title}</p>
              <div className="flex justify-between w-full mt-5">
                <p className="font-size-12 dark-disable">
                  {second2Date(add_time)}
                </p>
                <p className="font-size-12 dark-disable">{source}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default App;
